import {Network} from "../../../network/Network";
import {ProductType} from "../../../models/product/ProductType";
import {HttpStatus} from "../../../network/status/HttpStatus";
import {INetworkComponent} from "../../../network/types/INetworkComponent";
import {
    CommunityBrandFactKind,
    ICommunityBrandFactModel
} from "../../../models/community/brand/ICommunityBrandFactModel";
import {WebSocketCommunityEventName} from "../../../network/socket/names/WebSocketCommunityEventName";
import {arrayRemove} from "../../../sedestral/framework/utilities/ArrayRemove";
import {Services} from "../../Services";
import {CommunityDocumentsService} from "../documents/CommunityDocumentsService";

export class CommunityBrandFactsService {

    public static updateEvents: ((facts: ICommunityBrandFactModel[]) => void)[] = [];

    public static dispose(): void {
        this.updateEvents = [];
    }

    public static init(): void {
        Network.on(ProductType.COMMUNITY, WebSocketCommunityEventName.COMMUNITY_BRAND_FACTS_UPDATE, (data: ICommunityBrandFactModel[]) => {
            this.updateEvents.forEach(value => value(data));
        });
    }

    static onUpdate(component: INetworkComponent, func: (facts: ICommunityBrandFactModel[]) => void) {
        this.updateEvents.push(func);
        component.onRemove(() => arrayRemove(this.updateEvents, func));
    }

    public static async list(communityId: string, component?: INetworkComponent): Promise<ICommunityBrandFactModel[] | undefined> {
        const request = await Network.get(ProductType.COMMUNITY, `/community/${communityId}/brand/facts`, component);
        return request?.status == HttpStatus.OK ? request.data as ICommunityBrandFactModel[] : undefined;
    }

    public static async create(communityId: string, kind: CommunityBrandFactKind, text: string, component: INetworkComponent): Promise<ICommunityBrandFactModel | undefined> {
        this.silence(component);
        const request = await Network.postJson(ProductType.COMMUNITY, `/community/${communityId}/brand/facts`, {kind: kind, text: text}, component);
        return this.result(request);
    }

    public static async update(communityId: string, factId: string, patch: { kind?: CommunityBrandFactKind, text?: string, active?: boolean }, component: INetworkComponent): Promise<ICommunityBrandFactModel | undefined> {
        this.silence(component);
        const request = await Network.putJson(ProductType.COMMUNITY, `/community/${communityId}/brand/facts/${factId}`, patch, component);
        return this.result(request);
    }

    public static async delete(communityId: string, factId: string, component: INetworkComponent): Promise<boolean> {
        const request = await Network.delete(ProductType.COMMUNITY, `/community/${communityId}/brand/facts/${factId}`, component);
        return request?.status == HttpStatus.OK;
    }

    private static silence(component: INetworkComponent) {
        if (component && !component.networkErrorsHandler?.find(value => value.status == HttpStatus.BAD_REQUEST && value.message == "none")) {
            Services.handleErrors(component, [{status: HttpStatus.BAD_REQUEST, message: "none"}]);
        }
    }

    private static result(request: any): ICommunityBrandFactModel | undefined {
        if (request?.status == HttpStatus.OK) {
            return request.data as ICommunityBrandFactModel;
        }
        if (request?.status == HttpStatus.BAD_REQUEST) {
            const key = request.data?.message;
            Network.router.static.components.notifications.notify(CommunityDocumentsService.errorLabel(key ?? ""), undefined, 4000, "error");
        }
        return undefined;
    }
}
